import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { useQuizContext } from '../../context/QuizContext';
import { LAB_VALUES_TABLE, TABLE_OPTION } from '../../constants/quiz';
import { Flex } from '@osmosis/react-ui/components/Box';
import { Table } from '@osmosis/react-ui/components/Table';
import { Icon } from '@osmosis/react-ui/components/Icon';
import { IconButton } from '@osmosis/react-ui/components/IconButton';
import { H4 } from '@osmosis/react-ui/components/Text';
import { Select } from '@osmosis/react-ui/components/Select';

/**
 * Lab Values component.
 */
const LabValues = () => {
  const [selectedOption, setSelectedOption] = useState('blood');
  const { showLab, setShowLab } = useQuizContext();
  const intl = useIntl();
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) =>
    setSelectedOption(e.target.value);
  const handleClose = () => setShowLab(!showLab);

  return (
    <Flex
      sx={{
        position: ['fixed', 'fixed', 'absolute'],
        zIndex: 10,
        top: ['105px', '100px', 0],
      }}
      width="100%"
      ml={[0, 0, 3]}
      height={['70vh', '75vh', '34vh']}
    >
      <Flex
        data-testid="lab-values"
        alignItems="center"
        flexDirection="column"
        justifySelf="flex-end"
        sx={{
          border: '2px solid ',
          boxShadow: 'large',
          borderRadius: '4px',
          borderColor: 'gray10',
          bg: 'bg-0',
          m: [0, 15, 0],
          boxSizing: 'border-box',
        }}
      >
        <Flex
          bg="gray5"
          width="100%"
          alignItems="center"
          overflowY="auto"
          justifyContent="center"
          p={12}
          sx={{
            borderBottom: '2px solid',
            borderColor: 'gray10',
            position: 'relative',
          }}
        >
          <H4 color="gray30">
            <FormattedMessage
              id="quiz.labvalues.header"
              defaultMessage="Lab values"
            />
          </H4>
          <IconButton
            data-testid="popup-close-button"
            fontSize={14}
            variant="transparent"
            color="gray30"
            sx={{
              position: 'absolute',
              right: 0,
              ':hover': { color: 'gray20' },
              ':active': { color: 'gray20' },
            }}
            icon={<Icon icon={faTimes} />}
            onClick={handleClose}
          />
        </Flex>
        <Flex
          flexDirection="column"
          width="100%"
          p={16}
          overflowY="auto"
          maxHeight="calc(90vh - 100px)"
        >
          <Flex flexDirection="column" alignItems="flex-start">
            <Select
              data-testid="lab-values_select"
              value={selectedOption}
              onChange={handleChange}
              mb="16px"
              sx={{
                fontWeight: 'bold',
                cursor: 'pointer',
              }}
            >
              {Object.entries(TABLE_OPTION).map(([key, option]) => (
                <option
                  data-testid={'table-option_option-' + key}
                  key={key}
                  value={key}
                >
                  {intl.formatMessage(option)}
                </option>
              ))}
            </Select>
            <Table
              tableData={
                LAB_VALUES_TABLE[
                  selectedOption as keyof typeof LAB_VALUES_TABLE
                ]
              }
            />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default LabValues;
